import { Helmet } from "react-helmet-async";

const SITE = "https://www.beadorecandles.com";
const BRAND = "BeAdoré Candles";
const DEFAULT_IMAGE = `${SITE}/products/tuscan-twilight.jpg`;

type Props = {
  title: string;
  description: string;
  path?: string;
  image?: string;
  type?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
};

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noIndex,
  jsonLd,
}: Props) {
  const url = `${SITE}${path}`;
  const fullTitle = title.includes(BRAND) ? title : `${title} | ${BRAND}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex ? <meta name="robots" content="noindex, nofollow" /> : null}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={BRAND} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd
        ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((blob, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(blob)}
            </script>
          ))
        : null}
    </Helmet>
  );
}
